"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDetailLinks = exports.getCurrentRoute = exports.replaceDetails = void 0;
const mithril_1 = __importDefault(require("mithril"));
function replaceDetails(to) {
    mithril_1.default.route.set(mithril_1.default.route.get().split(/\&/)[0] + "&" + to);
}
exports.replaceDetails = replaceDetails;
function getCurrentRoute() {
    return `#!/${mithril_1.default.route.get().split("&")[0]}&`;
}
exports.getCurrentRoute = getCurrentRoute;
function getDetailLinks(name, id, action = "show") {
    let to;
    if (id)
        to = `name=${name}&id=${id}&action=${action}`;
    else
        to = `name=${name}&action=${action}`;
    return mithril_1.default.route.get().split(/\&/)[0] + "&" + to;
}
exports.getDetailLinks = getDetailLinks;
